'use client';

import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { createContext, useMemo, type PropsWithChildren } from 'react';
import { Loader } from '@/components/layout/loading';
import type { nonProjectDalFactory } from '@/data/dal/dalFactory';
import { projectDalFactory } from '@/data/dal/dalFactory';
import { useEnvironment } from './useEnvironment';
import { useNonProjectDal } from './useNonProjectDal';
import { useUser } from './useUser';
export const DalContext = createContext<(ReturnType<typeof projectDalFactory> & ReturnType<typeof nonProjectDalFactory>) | null>(null);
export const DalProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    currentProjectId
  } = useUser();
  if (!currentProjectId) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LoaderComponent />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== children) {
    t1 = <ProviderWrapper>{children}</ProviderWrapper>;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const ProviderWrapper = ({
  children
}: PropsWithChildren) => {
  const {
    nonProjectDal,
    httpClient,
    configuration
  } = useNonProjectDal();
  const {
    currentProjectId,
    isEmployee
  } = useUser();
  const {
    isTest
  } = useEnvironment();
  const dal_0 = useMemo(() => {
    const projectDal = projectDalFactory(httpClient, configuration, currentProjectId);
    const dal = {
      ...projectDal,
      ...nonProjectDal
    };
    if (isTest && typeof window !== 'undefined') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, react-hooks/immutability
      (window as any).populateTestData = async () => {
        const urls = [`/projects/${currentProjectId}/populate?version=1`, `/projects/${currentProjectId}/metering/populate?version=1`, `/projects/${currentProjectId}/inventory/populate-backup-jobs?version=1`, `/projects/${currentProjectId}/visibility/populate?version=1`, `/projects/${currentProjectId}/inventory/populate?version=1`, `/projects/${currentProjectId}/search/populate?version=1`];
        for (const url of urls) {
          await httpClient.put(url, '{}');
        }
      };
    }
    if (isEmployee && typeof window !== 'undefined') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, react-hooks/immutability
      (window as any).dal = dal;
    }
    return dal;
  }, [configuration, currentProjectId, isTest, httpClient, isEmployee, nonProjectDal]);
  return <DalContext.Provider value={dal_0}>{children}</DalContext.Provider>;
};
const LoaderComponent = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box className="h-full" sx={{
      background: "var(--mui-palette-background-pageGradient)"
    }}><Loader /></Box>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};